export function yahooFinanceJpUrl(stockCode: string): string {
  return `https://finance.yahoo.co.jp/quote/${stockCode}.T`
}

export function googleSearchUrl(companyName: string): string {
  return `https://www.google.com/search?q=${encodeURIComponent(`${companyName} 株主優待 ブログ`)}`
}
